import { render, staticRenderFns } from "./SuccessPayment.vue?vue&type=template&id=f385533a&scoped=true"
import script from "./SuccessPayment.vue?vue&type=script&lang=js"
export * from "./SuccessPayment.vue?vue&type=script&lang=js"
import style0 from "./SuccessPayment.vue?vue&type=style&index=0&id=f385533a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f385533a",
  null
  
)

export default component.exports